import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = ["stroke"];
import { appState } from '@/composable/appState';
import { CHAT_ICONS } from '@/helper/const';
import { ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MessageChatSquare',
    setup(__props) {
        const stroke = ref('#475467');
        const setInitialStrokeColor = () => {
            const defaultValue = appState.chatWidgetSettingsData.chatIcon;
            if (defaultValue === CHAT_ICONS.MESSAGE_CHAT_SQUARE) {
                stroke.value = '#155EEF';
            }
            else {
                stroke.value = '#475467';
            }
        };
        watch(() => appState.chatWidgetSettingsData.chatIcon, newValue => {
            if (newValue === CHAT_ICONS.MESSAGE_CHAT_SQUARE) {
                stroke.value = '#155EEF';
            }
            else {
                stroke.value = '#475467';
            }
        });
        setInitialStrokeColor();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                _createElementVNode("path", {
                    d: "M11.6663 17.5007L8.07854 21.1333C7.57809 21.64 7.32786 21.8934 7.11279 21.9112C6.92619 21.9267 6.74349 21.8517 6.62163 21.7096C6.48116 21.5457 6.48116 21.1896 6.48116 20.4774V18.6575C6.48116 18.0186 5.95793 17.5563 5.32575 17.4637V17.4637C3.79571 17.2396 2.59408 16.038 2.36996 14.5079C2.33301 14.2556 2.33301 13.9546 2.33301 13.3525V7.93399C2.33301 5.9738 2.33301 4.99371 2.71449 4.24502C3.05004 3.58645 3.58547 3.05102 4.24404 2.71546C4.99273 2.33398 5.97282 2.33398 7.93301 2.33398H16.5663C18.5265 2.33398 19.5066 2.33398 20.2553 2.71546C20.9139 3.05102 21.4493 3.58645 21.7849 4.24502C22.1663 4.99371 22.1663 5.9738 22.1663 7.93398V12.834M22.1663 25.6673L19.6272 23.902C19.2703 23.6539 19.0918 23.5298 18.8976 23.4418C18.7252 23.3637 18.544 23.3069 18.3578 23.2726C18.1482 23.234 17.9308 23.234 17.4961 23.234H15.3997C14.0929 23.234 13.4395 23.234 12.9404 22.9797C12.5013 22.756 12.1444 22.399 11.9207 21.96C11.6663 21.4608 11.6663 20.8074 11.6663 19.5007V16.5673C11.6663 15.2605 11.6663 14.6071 11.9207 14.108C12.1444 13.669 12.5013 13.312 12.9404 13.0883C13.4395 12.834 14.0929 12.834 15.3997 12.834H21.933C23.2398 12.834 23.8932 12.834 24.3923 13.0883C24.8314 13.312 25.1883 13.669 25.412 14.108C25.6663 14.6071 25.6663 15.2605 25.6663 16.5673V19.734C25.6663 20.8212 25.6663 21.3648 25.4887 21.7936C25.2519 22.3653 24.7977 22.8196 24.2259 23.0564C23.7971 23.234 23.2535 23.234 22.1663 23.234V25.6673Z",
                    stroke: stroke.value,
                    "stroke-width": "2.33333",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                }, null, 8 /* PROPS */, _hoisted_2)
            ]));
        };
    }
});
